import { trans } from "@mongez/localization";
import { Close, Search } from "~/design-system/components/icons";
import {
  cartDrawerAtom,
  headerMenuAtom,
  searchAtom,
} from "~/modules/shared/atoms";
import { CartButton } from "./CartButton";
import { HeaderButton } from "./HeaderButton";
import { UserButton } from "./UserButton";

export function UserButtons() {
  const searchOpened = searchAtom.useOpened();

  return (
    <>
      <div className="block lg:hidden">
        <HeaderButton
          onClick={() => {
            searchAtom.toggle();
            headerMenuAtom.close();
            cartDrawerAtom.close();
          }}
          data-ignore-outside-clicks
          title={searchOpened ? trans("closeSearch") : trans("openSearch")}
          aria-label={searchOpened ? trans("closeSearch") : trans("openSearch")}
        >
          {searchOpened ? (
            <Close className="size-7" />
          ) : (
            <Search className="size-7" />
          )}
        </HeaderButton>
      </div>
      <div className="hidden items-center gap-2 lg:flex">
        <HeaderButton
          onClick={() => {
            searchAtom.toggle();
            headerMenuAtom.close();
          }}
          data-ignore-outside-clicks
          title={searchOpened ? trans("closeSearch") : trans("openSearch")}
          aria-label={searchOpened ? trans("closeSearch") : trans("openSearch")}
        >
          {searchOpened ? (
            <Close className="size-7" />
          ) : (
            <Search className="size-7" />
          )}
        </HeaderButton>
        <UserButton />
        <CartButton />
      </div>
    </>
  );
}
